/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
export const isMobile = () => (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
